import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Frame, List, Typography } from '@klarna/bubble-ui';
import { VerticalRhythm } from 'mage-components';

import { translationParser } from '@/selectors/utils';

const InformationContainer = ({ t, Icon = null, tPrefix, hasFooter = false, items }) => {
  return (
    <>
      {Icon && (
        <>
          <Icon />
          <VerticalRhythm spacing={6} />
        </>
      )}
      <Typography textToken="text-style/headings/blocks/bold/primary">
        {t(`${tPrefix}.title`)}
      </Typography>
      <VerticalRhythm spacing={6} />
      <Typography textToken="text-style/headings/blocks/medium/tertiary">
        {t(`${tPrefix}.subtitle`)}
      </Typography>
      <VerticalRhythm spacing={6} />
      <Frame
        cornerRadiusToken="corner-radius/none"
        backgroundColorToken="colors/backgrounds/subtle-inline"
        paddingToken="space/400"
      >
        <Typography textToken="text-style/text/super-paragraphs/body/regular">
          {t(`${tPrefix}.content.title`)}
        </Typography>
        <VerticalRhythm spacing={2} />
        <List>
          {Object.values(items).map((item, i) => (
            <List.Item key={i}>{item}</List.Item>
          ))}
        </List>
      </Frame>
      {hasFooter && (
        <>
          <VerticalRhythm spacing={6} />
          <Typography textToken="text-style/text/super-paragraphs/body/regular">
            {t(`${tPrefix}.footer`)}
          </Typography>
        </>
      )}
      <VerticalRhythm spacing={{ mobile: 6, tablet: 10 }} />
    </>
  );
};

InformationContainer.propTypes = {
  t: PropTypes.func.isRequired,
  tPrefix: PropTypes.string.isRequired,
  hasFooter: PropTypes.bool,
  Icon: PropTypes.element,
  items: PropTypes.object,
};

export default connect((state, { tPrefixList, merchantCountry }) => ({
  items: translationParser(state)(tPrefixList, merchantCountry) || [],
}))(InformationContainer);
